import React from "react";

import Chrome from "EmployerApplication/Chrome";
import { Provider } from "react-redux";

import CreateAccountPage from "./CreateAccountPage";
import createStore, { type Store } from "./createStore";

type Props = {
  match: {
    params: {
      account: string;
      companyIdToken: string;
    };
  };
};

export class App extends React.Component<Props> {
  store: Store;

  constructor() {
    super();
    // The app uses a "fake" store, meaning there the store doesn't respond
    // to changes, and is only just used to populate the initial state so that
    // the application menu can function correctly.
    this.store = createStore();
  }

  render() {
    const { account, companyIdToken } = this.props.match.params;

    return (
      <Provider store={this.store}>
        <Chrome title="Connect Quickbooks Account" showAgentHeader={false}>
          <CreateAccountPage showSiAccount={account == "si"} companyIdToken={companyIdToken} />
        </Chrome>
      </Provider>
    );
  }
}

export default App;
